import {
  DateRangePicker,
  type DateRangePickerProps,
} from "@mui/x-date-pickers-pro";
import { parseAsIsoDate, useQueryStates } from "nuqs";

export interface QueryDateRangePickerProps extends DateRangePickerProps<any> {
  fromQueryKey: string;
  toQueryKey: string;
  fromLabel: string;
  toLabel: string;
  required?: boolean;
  onChangeCallback?: (from: Date | null, to: Date | null) => void;
}

export function QueryDateRangePicker({
  fromQueryKey,
  toQueryKey,
  fromLabel,
  toLabel,
  required,
  onChangeCallback,
  ...dateRangePickerProps
}: QueryDateRangePickerProps) {
  const [dates, setDates] = useQueryStates({
    [fromQueryKey]: parseAsIsoDate,
    [toQueryKey]: parseAsIsoDate,
  });

  return (
    <DateRangePicker
      localeText={{
        start: required ? `* ${fromLabel}` : fromLabel,
        end: required ? `* ${toLabel}` : toLabel,
      }}
      value={[dates[fromQueryKey] ?? null, dates[toQueryKey] ?? null]}
      onChange={([newFrom, newTo]) => {
        setDates({ [fromQueryKey]: newFrom, [toQueryKey]: newTo });
        if (typeof onChangeCallback === "function") {
          onChangeCallback(newFrom, newTo);
        }
      }}
      {...dateRangePickerProps}
    />
  );
}
